import React, { useRef, useState, useEffect, useCallback } from 'react';
import { RefreshControl, View, Text } from 'react-native';
import PropTypes from 'prop-types';
import Theme from 'Theme';
import { Button, Carousel, Promo, withConfirmationModal } from 'LocalGluons';
import NavigationService from 'NavigationService';
import { t } from 'Locale';
import TvGuide from 'LocalGluons/components/TvGuidePreview';
import { getItemStartTime, getProgressPercentage, getAssetImageUrl } from 'Utils';
import { withStore } from 'Store';
import { isContentBlocked, isContentLocked } from 'Utils/parentalControlUtils';
import { Device } from 'DeviceUtils';
import { PageItem } from 'Pages/Page/PageItem';
import { Playlist } from '@24i/st-api-connector';
import { logEvent } from 'AppManager';
import { handleScroll } from 'ReduxStore/webMenu';
import { useAppSelector, useAppDispatch } from 'ReduxStore/hooks';
import ContentWrapper from '../ContentWrapper';
import { PageItemTypeEnum, linkedData } from '../../../options';
import { useNavigationPropsContext } from '../../Navigation/navigationPropsContext';
import { dataToExport } from '../../App/index';
import { useIsFocused } from '@react-navigation/native';

import defaultStyles from './WatchTV.jss';
// updated component
const WatchTV = (props) => {
    const [promoData, setPromoData] = useState(null);
    const [promoData1, setPromoData1] = useState(null);
    const [promoData2, setPromoData2] = useState(null);
    const [promoDataLoaded, setPromoDataLoaded] = useState(false);
    const [singleRowCarouselsData, setSingleRowCarouselsData] = useState([]);
    const [updatePromoData, setUpdatePromoData] = useState(false);
    const [refreshing, setRefreshing] = useState(false);
    const [isRefreshEnabled, setIsRefreshEnabled] = useState(false);
    const [childRefresherValue, setChildRefresherValue] = useState(null);
    const { navigate } = useNavigationPropsContext();
    let isRefreshEnabledTimeout = useRef();

    const dispatch = useAppDispatch();
    const {
        navigation,
        setProtectedContent,
        setPlayerData,
        parentalLockConfig,
        appManager,
        route,
        setScrollY,
        scrollY
    } = props;
    let navWillFocusListener = useRef();
    const api = appManager.getApi();

    const rerouteToDetail = async () => {
        if (dataToExport.isDetail) {
            const item = await api.fetchProgramDetail({ scheduleId: dataToExport.idOfDeteail });
            navigate('Details', { item }, { id: dataToExport.idOfDeteail, type: item.modelType });
        }
    };

    useEffect(() => {
        NavigationService.setAppNavigationInstance(navigation);
        initializePage();
        rerouteToDetail();
        navWillFocusListener = navigation.addListener('focus', () => {
            setUpdatePromoData(true);
        });
        enableRefreshAfterTimeout();
    }, []);

    const onRefresh = () => {
        setPromoData(null);
        setPromoData1(null);
        setPromoData2(null);
        setPromoDataLoaded(false);
        setSingleRowCarouselsData([]);
        setUpdatePromoData(false);
        setIsRefreshEnabled(false);

        initializePage();

        // if (childRefresherValue) childRefresher();

        if (isRefreshEnabled) {
            clearTimeout(isRefreshEnabledTimeout);
        }
    };

    const onTvGuideButtonPress = () => {
        navigation.navigate('TvGuide');
        // navigate('TvGuide');
        logEvent({
            type: 'user-flow',
            subtype: 'watch-tv',
            content1: 'open-epg-button',
            content2: '',
            context: '/epg'
        });
    };

    const onPromoItemPress = (item, data) => {
        if (data.isBlocked) {
            setProtectedContent(item, () => {
                navigate('Details', { item }, { id: item.data.id, type: item.modelType });
            });
        } else {
            navigate('Details', { item }, { id: item.data.id, type: item.modelType });
        }
    };

    const onItemPress = (item) => {
        navigate('Details', { item }, { id: item.data.id, type: item.modelType });
    };

    const onViewAllPress = useCallback(
        (title, _, __, items) => {
            navigate('ViewAll', { title, items });
        },
        [navigation]
    );

    const getPromoItem = useCallback((item) => {
        const ageBlock = isContentBlocked(item.data?.parentalRating, parentalLockConfig);
        const adultLock = isContentLocked(item.isAdult(), parentalLockConfig);
        const startTime = getItemStartTime(item.data);
        const subTitle =
            item.data.channelname && startTime && `${item.data.channelname} | ${startTime}`;
        return {
            item,
            subTitle,
            isBlocked: ageBlock,
            isAgeBlocked: ageBlock,
            isAdultLocked: adultLock,
            header: item.getCategory(),
            title: adultLock ? t('COMMON.LOCKED_ADULT_CONTENT') : item.getTitle(),
            progress: getProgressPercentage(item),
            imageUrl: adultLock ? '' : getAssetImageUrl(item, 'PREVIEW')
        };
    }, []);

    const promoItemsLoaded = useCallback(
        (item, items, force) => {
            if (!promoData || updatePromoData || force) {
                if (item) {
                    setPromoData(getPromoItem(item));
                    setPromoData1(getPromoItem(items[0]));
                    setPromoData2(getPromoItem(items[1]));
                    setPromoDataLoaded(true);
                    setUpdatePromoData(false);
                } else {
                    setPromoDataLoaded(true);
                }
            }
        },
        [promoData, updatePromoData, getPromoItem]
    );

    const enableRefreshAfterTimeout = useCallback(() => {
        isRefreshEnabledTimeout = setTimeout(() => {
            setIsRefreshEnabled(true);
        }, 30 * 1000);

        return () => clearTimeout(isRefreshEnabledTimeout);
    }, []);

    const initializePage = useCallback(async () => {
        try {
            const { items = [] } = await appManager.fetchPageData(route.params?.reference);
            const pageItems = items.map((item) => new PageItem(item));
            await Promise.all(
                pageItems.map((pageItem, index) => pageItem.downloadCarouselData(index))
            );
            const singleRowCarouselsDataUpdate = pageItems.reduce((inputArray, pageItem) => {
                const carouselData = pageItem.getCarouselData();
                let finalArray = inputArray;
                if (
                    [
                        PageItemTypeEnum.SINGLE_ROW,
                        PageItemTypeEnum.SINGLE_HIGHLIGHT,
                        PageItemTypeEnum.DOUBLE_ROW
                    ].includes(carouselData.type)
                ) {
                    finalArray = Array.isArray(inputArray) ? inputArray : [];
                    finalArray.push(carouselData);
                }
                return finalArray;
            });

            setSingleRowCarouselsData(singleRowCarouselsDataUpdate);
        } catch (error) {
            console.log(error);
        }
    }, []);

    const resetChildRefresher = (refresher) => {
        setChildRefresherValue(() => refresher);
    };

    useEffect(() => {
        navWillFocusListener = navigation.addListener('focus', () => {
            setUpdatePromoData(true);
        });
        enableRefreshAfterTimeout();
        NavigationService.setAppNavigationInstance(navigation);
        return () => {
            navWillFocusListener;
            clearTimeout(isRefreshEnabledTimeout);
        };
    }, [navigation, enableRefreshAfterTimeout]);

    useEffect(() => {
        if (!isRefreshEnabled) {
            enableRefreshAfterTimeout();
        }
    }, [isRefreshEnabled, enableRefreshAfterTimeout]);

    return (
        <ContentWrapper
            onScroll={(e) => dispatch(handleScroll(e))}
            scrollEventThrottle={NavigationService.DEFAULT_SCROLL_THROTTLE}
            refreshControl={
                <RefreshControl
                    colors={[Theme.primaryActiveColor]}
                    tintColor={Theme.primaryActiveColor}
                    refreshing={refreshing}
                    onRefresh={onRefresh}
                    enabled={isRefreshEnabled}
                />
            }
        >
            <View style={defaultStyles.tvGuideRow}>
                <View style={defaultStyles.tvGuideRowTitle}>
                    <Text style={defaultStyles.tvGuideRowTitleText}>
                        {t('COMMON.NOW_ON_TV').toUpperCase()}
                    </Text>
                </View>
                <Button
                    style={{
                        button: defaultStyles.tvGuideButton
                    }}
                    onPress={onTvGuideButtonPress}
                    iconName="tv_guide"
                    title={t('TV.GUIDE')}
                    testID="EPG_button"
                />
            </View>
            <View
                style={{
                    flexDirection: 'row',
                    height: 500,
                    alignSelf: 'stretch',
                    marginHorizontal: Theme.primaryMargin
                }}
            >
                <View style={{ flex: 1, height: 500 }}>
                    <Promo
                        testID="watchTV_top_promo"
                        data={promoData}
                        style={[defaultStyles.promo, { height: 300 }]}
                        onItemPress={onPromoItemPress}
                        loaded={promoDataLoaded}
                    />
                    <View style={defaultStyles.promoContainer}>
                        <Promo
                            testID="watchTV_second_promo"
                            data={promoData1}
                            style={[defaultStyles.promo, { height: 180, marginRight: 10 }]}
                            onItemPress={onPromoItemPress}
                            loaded={promoDataLoaded}
                        />
                        <Promo
                            testID="watchTV_third_promo"
                            data={promoData2}
                            style={[defaultStyles.promo, { height: 180, marginLeft: 10 }]}
                            onItemPress={onPromoItemPress}
                            loaded={promoDataLoaded}
                        />
                    </View>
                </View>
                <View style={defaultStyles.detailsContainer}>
                    <TvGuide
                        setChildRefresher={resetChildRefresher}
                        updatePromoData={updatePromoData}
                        onSelectChannel={(currentProgram) => {
                            setPlayerData({
                                item: currentProgram
                            });
                        }}
                        onSelectProgram={(currentProgram) => {
                            navigate(
                                'Details',
                                { item: currentProgram },
                                { id: currentProgram.data.id, type: currentProgram.modelType }
                            );
                            logEvent({
                                type: 'user-flow',
                                subtype: 'watch-tv',
                                content1: 'channel-list-open-detail',
                                content2: '',
                                context: '/detail'
                            });
                        }}
                        promoItemsLoaded={promoItemsLoaded}
                        style={defaultStyles.tvGuide}
                        setScrollY={setScrollY}
                        scrollY={scrollY}
                    />
                </View>
            </View>
            <View style={defaultStyles.carouselsContainer}>
                {singleRowCarouselsData?.map?.((carousel) => {
                    const { items } = carousel;
                    if (items.length > 0) {
                        return (
                            <Carousel
                                key={`${carousel.key}_${items.length}`}
                                testId={carousel.testId}
                                style={defaultStyles.carousel}
                                title={Playlist.replaceLabelTags(carousel.title)}
                                items={items || []}
                                onViewAllPress={(title, _, __, items) => {
                                    onViewAllPress(title, _, __, items);
                                    logEvent({
                                        type: 'user-flow',
                                        subtype: navigation.getState().routes[0].name,
                                        content1: 'carousel-show-more',
                                        content2: carousel.title,
                                        context: '/show-all'
                                    });
                                }}
                                onItemPress={(item) => {
                                    onItemPress(item);
                                    logEvent({
                                        type: 'user-flow',
                                        subtype: navigation.getState().routes[0].name,
                                        content1: 'carousel-open-detail',
                                        content2: carousel.title,
                                        context: '/detail'
                                    });
                                }}
                                forcePortraitViewPackshotDimensions={Device.isPhone}
                            />
                        );
                    }
                    return null;
                })}
            </View>
        </ContentWrapper>
    );
};

const withScreenFocusOnly = (WrappedComponent) => {
    return (props) => {
        const isFocused = useIsFocused();
        const [scrollY, setScrollY] = useState(0);
        if (!isFocused) return null;

        return (
            <WrappedComponent
                {...props}
                isFocused={isFocused}
                setScrollY={setScrollY}
                scrollY={scrollY}
            />
        );
    };
};

export default withScreenFocusOnly(withConfirmationModal(withStore(WatchTV)));
